import React, { useEffect, useState } from "react";

import "../../index.css";

import ImgProfile from "./prof-pic.png";
import { toast } from 'react-toastify';

const ImgUpload = ({ onChange, src, required }) => (
  <label htmlFor="photo-upload" className="custom-file-upload fas">
    <div className="img-wrap img-upload">
      <img
        htmlFor="photo-upload"
        className="img-profile-pic"
        src={src}
        alt="Profile Preview"
      />
    </div>
    <input
      id="photo-upload"
      type="file"
      onChange={onChange}
      style={{ display: "none" }}
      required={required}
      size={10000}
      accept=".jpg, .jpeg, .png, .webp"
    />
  </label>
);

const Edit = ({ children, doNotLabel }) => (
  <div
    className="card border-0 mt-2 d-flex justify-content-center align-items-center"
    style={{ height: "168px" }}
  >
    {children}
    {!doNotLabel && <span className="profile-pic">Escolher foto</span>}
  </div>
);

const CardProfile = ({ required, setValue, onPhotoUpload, preValue, style, doNotLabel }) => {
  const [image, setImage] = useState("");
  const [active, setActive] = useState("edit");

  let imagePreview;

  imagePreview = preValue ? preValue : ImgProfile;
  useEffect(() => {
    setValue("profile_photo", image);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setImage]);

  const [preview, setPreview] = useState(imagePreview);

  useEffect(() => {
    setPreview(imagePreview);
  }, [imagePreview]);

  const photoUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
  
    // Tipos de arquivos permitidos
    const allowedTypes = ['image/webp', 'image/jpeg', 'image/png', 'image/svg+xml'];
  
    // Verifica se o tipo do arquivo é permitido
    if (!allowedTypes.includes(file.type)) {
      toast.error("Tipo de arquivo não permitido. Apenas webp, jpg, jpeg, png e svg são aceitos.");
      return;
    }
  
    // Verifica se o tamanho do arquivo é maior que 10MB
    const maxSize = 10 * 1024 * 1024; // 10MB em bytes
    if (file.size > maxSize) {
      toast.error("O arquivo excede o tamanho máximo permitido de 10MB.");
      return;
    }
  
    reader.onloadend = (event) => {
      const setFile = event.target.result;
      setImage(setFile);
      const setFilePreview = reader.result;
      setPreview(setFilePreview);
      onPhotoUpload({ image, setFile, setFilePreview });
    };
  
    reader.readAsDataURL(file);
  }; 

  const handleSubmit = (e) => {
    e.preventDefault();
    let activeP = active === "edit" ? "profile" : "edit";
    setActive(activeP);
  };

  return (
    <div style={style}>
      {active === "edit" && (
        <Edit onSubmit={handleSubmit} doNotLabel={doNotLabel}>
          <ImgUpload onChange={photoUpload} src={preview} required={required} />
        </Edit>
      )}
    </div>
  );
};

export default CardProfile;
